<template>
  <div class="main-footer sides-padding">
    <div class="main-footer__container container">
      <div class="main-footer__columns">
        <div class="main-footer__column">
          <router-link :to="{ name: 'home' }" title="На главную">
            <FileIconComponent class="main-footer__logo" name="logo" />
          </router-link>
          <span class="main-footer__copyright">
            {{ new Date().getFullYear() }} © ИП Джарулаев Джарула Физулиевич <br />
            Интернет-магазин детских товаров.
          </span>
        </div>
        <nav
          v-if="pages && pages.length"
          class="main-footer__column main-footer__column-links"
        >
          <h4 class="main-footer__column-title">О компании</h4>
          <ul class="main-footer__column-list">
            <li v-for="(page, i) in pages" :key="i">
              <router-link
                :to="{ name: 'static', params: { id: page.id } }"
                class="main-footer__column-link"
              >
                <span>{{ page.title }}</span>
                <IconComponent name="arrow-right-1" />
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ name: 'documents' }"
                class="main-footer__column-link"
              >
                <span>Документы</span>
                <IconComponent name="arrow-right-1" />
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ name: 'news' }"
                class="main-footer__column-link"
              >
                <span>Блог</span>
                <IconComponent name="arrow-right-1" />
              </router-link>
            </li>
          </ul>
        </nav>
        <nav class="main-footer__column main-footer__column-links">
          <h4 class="main-footer__column-title">Интернет магазин</h4>
          <ul class="main-footer__column-list">
            <li v-for="(item, i) in shopPages" :key="i">
              <router-link class="main-footer__column-link" :to="item.route">
                <span>{{ item.title }}</span>
                <IconComponent name="arrow-right-1" />
              </router-link>
            </li>
          </ul>
        </nav>
        <nav class="main-footer__column main-footer__column-contacts">
          <h4 class="main-footer__column-title">Контакты</h4>
          <ContactsComponent />
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import FileIconComponent from "components/FileIconComponent.vue";
import ContactsComponent from "components/ContactsComponent.vue";
import IconComponent from "components/IconComponent.vue";

export default {
  name: "MainFooterComponent",
  data() {
    return {
      shopPages: [
        {
          title: "Акции",
          route: { name: "shares" },
        },
        // {
        //   title: "Школа мам",
        //   route: { name: "school" },
        // },
        {
          title: "Вопросы и ответы",
          route: { name: "" },
        },
      ],
    };
  },
  computed: {
    pages() {
      return this.$store.state.pages || [];
    },
  },
  components: { IconComponent, ContactsComponent, FileIconComponent },
};
</script>

<style lang="stylus">
.main-footer {
  display flex
  justify-content center

  &__container {
    display flex
    flex-direction column
    align-items flex-start
    justify-content flex-start;
  }

  &__columns {
    padding 50px 0
    display flex
    grid-gap 30px
    width 100%
    +below(990px) {
      grid-gap 34px 30px
      flex-wrap wrap
    }
    +below(840px) {
      padding 30px 0
    }
    +below(480px) {
      grid-gap 20px
    }
  }

  &__column {
    display flex
    flex-direction column
    gap 15px
    width calc(25% - 23px)
    +below(990px) {
      width calc(50% - 15px)

      &-links {
        order 1
      }

      &:not(&-links) {
        order 2
        +below(680px) {
          width 100%
        }
      }
    }
    +below(420px) {
      width 100%
    }

    &-contacts:not(&-links) {
      min-width 280px
      +below(680px) {
        order 1
      }
    }
  }

  &__column-title {
    font-weight: 700;
    font-size: 1.125em
    line-height: 1.4
    margin-bottom 0
    padding-bottom 15px
    border-bottom 1px solid var(--gray)
    +below(420px) {
      font-size 1em
      padding-bottom 10px
    }
  }

  &__column-list {
    display flex
    flex-direction column
    justify-content flex-start
    gap 10px
  }

  &__column-link {
    font-weight: normal;
    font-size: 0.875em
    line-height: 145%;
    display: flex;
    align-items: center;
    justify-content space-between
    gap: 10px
    padding 3px 0

    .icon {
      width 10px
      height: 10px
    }
  }

  &__logo {
    max-width: 270px
    height auto
  }

  &__copyright {
    font-size: 0.875em
    line-height: 145%;
  }
}
</style>
